import {
  Accordion,
  AccordionProps,
  accordionSummaryClasses,
  cardHeaderClasses,
} from '@rossum/ui/material';

export const ActivityAccordion = (props: AccordionProps) => (
  <Accordion
    {...props}
    sx={{
      scrollMargin: '16px',
      '&&': {
        marginBottom: '0px',
        marginTop: '8px',
      },
      [`.${accordionSummaryClasses.root}`]: {
        paddingLeft: 0,
      },
      [`&& .${accordionSummaryClasses.content}`]: {
        marginTop: '0px',
        marginBottom: '0px',
      },
      [`.${cardHeaderClasses.title}`]: theme => theme.typography.body1,
      ...props.sx,
    }}
  />
);
